import React, { useEffect, useState } from "react";
import Navbar from "./navbar";
import { useNavigate } from "react-router-dom";
import  './Resources/Actions.css';
import './App.css';


export default function Userdayclosing(){
    const navigate = useNavigate();
    
    const [date,setDate] = useState(new Date().toISOString().slice(0,10));
    const nextdate = new Date(date);
    nextdate.setDate(nextdate.getDate()+1);
    var tomorrow = nextdate.toISOString().slice(0,10)

    console.log(tomorrow);
    const API_URL = process.env.REACT_APP_WEB_API_KEY;
    
    const[userloan,setUserloan]= useState([]);
    const[ramount, setRamount] = useState([]);
    const[intamount, setIntamount] = useState([]);
    const[fineamount,setFineamount] = useState([]);
    const[docamount,setDocamount] = useState([]);
    const[expamount, setExpamount] = useState([]);
    const[loanamount,setLoanamount] = useState(0);
    const[closinguserid,setClosinguserid] = useState(0);
    const authorizeid = localStorage.getItem("userid") ;
    const[checked,setChecked] = useState(false);
    const usertype = parseInt(localStorage.getItem("utype"));
    const [uid, setUid] = useState(localStorage.getItem("userid"));
    const [settings, setSettings] = useState([]);
    
    //let loanamount = 0;
    

useEffect(()=>{
    fetch(API_URL+"api/Userloan/GetUserLonaForCurrentDate?closingdate="+document.getElementById('ldate').value)
    .then(response => response.json())
    .then(data => {setUserloan(data)}); 

    fetch(API_URL+"api/ReceiptKey/GetCommonSettings")
        .then(res=>res.json())
        .then((data)=>{setSettings(data)});

},[date])

console.log(userloan);

console.log(checked);


function fetchdetails()
{
    setClosinguserid(document.getElementById('user').value);

    if (document.getElementById('user').value === '')
    {
        valididDialog();
    }
    else
    {
        var finduser = userloan.filter( e => {if(Number(document.getElementById('user').value) === e.Userid) {return e}});
    
        {finduser.length > 0 ? setLoanamount(finduser[0].LoanAmount+finduser[0].LoanTopUp) : setLoanamount(0)}

        console.log(finduser);
        console.log(loanamount);

    //to find loanreturned status 
    // var check =  userloan.filter(e =>{if(e.Userid === document.getElementById('user').value && e.LoanReturned === 1) return true});
    
        if (finduser.length > 0 && finduser[0].LoanReturned === 1)
        {
        daycloseddialog();
        }
        else
        {

        fetch(API_URL+"api/Payment/GetDailyCollectionByUser?rdate="+date +"&edate="+date+"&userid="+document.getElementById('user').value)
        .then(response => response.json())
        .then(data => {setRamount(data)});
    
        fetch(API_URL+"api/Interest/GetInterestByUser?sdate="+date+"&edate="+date+"&userid="+document.getElementById('user').value)
        .then(response => response.json())
        .then(data => {setIntamount(data)});
        
        fetch(API_URL+"api/Fine/GetFineByUser?sdate="+date+"&edate="+date +"&userid="+document.getElementById('user').value)
        .then(response => response.json())
        .then(data => {setFineamount(data)});

        fetch(API_URL+"api/Loan/GetLoanByUser?sdate="+date+"&edate="+date+"&userid="+document.getElementById("user").value)
        .then(response => response.json())
        .then(data => {setDocamount(data)});

        fetch(API_URL+"api/Expense/GetExpensesByUser?sdate="+date+"&edate="+date+"&userid="+document.getElementById('user').value)
        .then(response => response.json())
        .then(data => {setExpamount(data)});
    
        }
    }

}

        const daycollection = ramount.reduce((tot,el)=>tot+ el.RAmount,0);
        const interest = intamount.reduce((tot,el)=>tot+ el.InterestAmount,0);
        const fine = fineamount.reduce((tot,el)=>tot+ el.FineAmount,0);
        const docfee = docamount.reduce((tot,el)=>tot+ el.DocumentFee,0);
        const loan = docamount.reduce((tot,el)=>tot+ el.LoanAmount,0);
        const Expense = expamount.reduce((tot,el)=>tot+ el.ExpenseAmount,0);


function sleep(ms) 
        {
            return new Promise(resolve => setTimeout(resolve, ms));
        }
         

function confirmclosing()
{
        if(document.getElementById('user').value !== '')
        {

            fetch(API_URL+"api/Userloan/CloseUserLoan?userid="+document.getElementById('user').value ,{method:"PUT",body:null})
           .then(response => response.json())
           .then(()=>{});

           const finalamount = daycollection+interest+fine+docfee+loanamount-loan-Expense;
           const data1 = new FormData();
           data1.append("date", new Date().toISOString().slice(0,10));
           data1.append("fordate",date);
           data1.append("amount",finalamount);
           data1.append("userid",closinguserid);
           data1.append("authorizeid",authorizeid);

           fetch(API_URL+"api/Dayclosing/EnterDayClosing",{method:"POST",body:data1})
           .then(response => response.json())
           .then(()=>{});
            
           
            showOKdialog();
        }
        else
        {
            valididDialog();
        }
}

function makenewloan()
{
    if(checked)
    {
         var userloanid = settings[0].UserLoanID + 1;
         var entdate = new Date().toISOString().slice(0,10);
         var lamount = daycollection+interest+fine+docfee+loanamount-loan-Expense;
         var userid = document.getElementById('user').value;
         

         var data = new FormData();
         data.append("userloanid",userloanid);
         data.append("userid",userid);
         data.append("entdate",entdate);
         data.append("fordate",date <  entdate ? entdate :tomorrow);
         data.append("lamount",lamount);
         data.append("authid",authorizeid);

 
         fetch(API_URL+"api/Userloan/EnterUserLoan",{method:"POST", body:data})
         .then(response => response.json())
         .then(()=>{});

        fetch(API_URL+"api/Userloan/IncrementUserLoanID?id="+userloanid,{method:"PUT",body:null})
        .then(response=>response.json())
        .then(()=>{});
     }
}

function showOKdialog()
{
  const dialog = document.getElementById('myDialog');
  dialog.showModal();
}
function daycloseddialog()
{
  const dialog = document.getElementById('closeddialog');
  dialog.showModal();
}

function closedialog()
{
  const dialog = document.getElementById('closeddialog');
  dialog.close();
  document.getElementById('user').value = '';
  setLoanamount(0);
  
}

function valididDialog()
{
  const dialog = document.getElementById('valididDialog');
  dialog.showModal();
}
function closeIDdialog()
{
  const dialog = document.getElementById('valididDialog');
  dialog.close();
  
}


return(
    <>
    <div className="reportheader"> 
            Day Closing Report
            <Navbar/>
    </div>      
    
        {usertype === 1 ? <>
        <label for="ldate"  style={{marginTop:"15px",marginLeft:"20px"}}>Date</label>
        <input id="ldate" type="date"  defaultValue = {date} style={{height:"25px",width:"200px",marginTop:"15px",marginLeft:"15px"}} onChange={(e)=>{setDate(e.target.value)}}></input><br/>
        <label for="user" style={{marginTop:"5px"}}>User ID</label>
        <input id="user" defaultValue={uid} style={{height:"25px",width:"200px",marginTop:"5px",marginLeft:"15px"}}></input></> 
        : 
        <>
        <label for="ldate"  style={{marginTop:"15px",marginLeft:"20px"}}>Date</label>
        <input id="ldate" type="date"  defaultValue = {date} style={{height:"25px",width:"200px",marginTop:"15px",marginLeft:"15px"}} readOnly></input><br/>
        <label for="user" style={{marginTop:"5px"}}>User ID</label>
        <input id="user" defaultValue={uid} style={{height:"25px",width:"200px",marginTop:"5px",marginLeft:"15px"}} disabled></input></> }
        <button type = "button"  className="fetchbutton" onClick={()=>{fetchdetails()}}>Fetch</button>
    <fieldset style={{marginTop:"2px",marginBottom:"2px"}}>
    <legend>Credit</legend>
    <table style={{width:"100%"}}>
        <tr>
            <td style={{textAlign:"left", width:"50%"}}>
            Day Collection
            </td>
            {ramount.length > 0 ?
            <td id = "daycollection">{daycollection}</td> :
            <td id = "daycollection">0</td>}
        </tr>
        <tr>
            <td style={{textAlign:"left", width:"50%"}}>Fine Amount</td>
            {fineamount.length > 0 ? 
            <td>{fine}</td> :
            <td id = "fineamount"> 0 </td>}
        </tr>
        <tr>
            <td style={{textAlign:"left", width:"50%"}}>interest</td>
            {intamount.length > 0 ?
            <td>{interest}</td>:
            <td id ="interest" >0</td>}
        </tr>
        <tr>
            <td style={{textAlign:"left", width:"50%"}}>Document Fee</td>
            {docamount.length > 0 ? 
            <td>{docfee}</td>:
            <td id = "documentfee">0</td>}
        </tr>
        <tr>
            <td style={{width:"50%",textAlign:"left",fontWeight:"bolder"}}>Opening Balance</td>
            <td id="loanamount" >{loanamount}</td>
        </tr>
        <tr>
            <td style={{width:"50%",fontWeight:"bolder"}}>Credit Total</td>
            <td style={{fontWeight:"bolder"}}>{daycollection+interest+fine+docfee+loanamount}</td>
        </tr>
    </table>
</fieldset>
<fieldset style={{marginBottom:"2px"}}>
    <legend>Debit </legend>
    <table style={{width:"100%"}}>
        <tr>
            <td style={{textAlign:"left", width:"50%"}}>
            Loan Distripution
            </td>
            {docamount.length > 0 ?
            <td>{loan}</td>:
            <td>0</td>}
        </tr>
        <tr>
            <td style={{textAlign:"left", width:"50%"}}>Expenses</td>
            {expamount.length > 0 ?
            <td>{Expense}</td>:
            <td>0</td>}
        </tr>
        
        <tr>
            <td style={{width:"50%",fontWeight:"bolder"}}>Debit Total</td>
            <td style={{fontWeight:"bolder"}}>{loan + Expense}</td>
        </tr>

    </table>
</fieldset>
<fieldset style={{marginBottom:"4px"}}>
    <legend>Closing</legend>
    <table style={{width:"100%"}}>
        <tr>
            <td style={{textAlign:"left", width:"50%"}}>Credit</td>
            <td style={{fontWeight:"bold"}}>{daycollection+interest+fine+docfee+loanamount}</td>
        </tr>
        <tr>
            <td style={{textAlign:"left", width:"50%"}}>Debit</td>
            <td style={{fontWeight:"bold"}}>{loan + Expense}</td>
        </tr>
        
        <tr>
            <td style={{width:"50%",fontWeight:"bolder"}}>Closing Balance</td>
            <td id="dayclose" style={{fontWeight:"bolder"}}> {daycollection+interest+fine+docfee+loanamount-loan-Expense} </td>
        </tr>

    </table>
</fieldset>
{usertype === 1 ? <>
<fieldset >
        <input id = "nextdayloan" type="checkbox" style={{height:"25px",width:"25px",marginLeft:"15px",marginTop:"0px"}}  onChange={()=>{setChecked(!checked)}}/>
        <label id ="nextdayloan" style={{fontSize:"20px",fontWeight:"bolder", marginBottom:"30px"}} >Forward Opening Balance</label> <br/>
        <button type = "button"  className="actionbuttons" style ={{marginTop:"25px"}}onClick={()=>{confirmclosing()}}>Confirm</button> 
        <button type = "button"  className="actionbuttons" style ={{backgroundColor:"red"}} onClick={()=>{navigate('/accounts')}}>Cancel</button>
</fieldset></>  : <><button type="button" className="backbutton" onClick={()=>{navigate('/home')}}>Back</button></>}
        <dialog id="myDialog" className="okdialog"> 
        <p>Day Closed For UserID  : {closinguserid}</p>
        <button className="okdialogbutton" onClick={()=>{makenewloan(); navigate('/accounts');}}>OK</button>
        </dialog>
        
        <dialog id = "closeddialog" className="okdialog">
            <p>Day Closing already Done for this User Id : {closinguserid}</p>
            <button className="okdialogbutton" onClick={()=>{closedialog()}}>OK</button>
        </dialog>
        
        <dialog id = "valididDialog" className="okdialog">
            <p>Please Enter Valid ID</p>
            <button className="okdialogbutton" onClick={()=>{closeIDdialog()}}>OK</button>
        </dialog>
    </>
)
}
